import { render, staticRenderFns } from "./EditAccountDetailPage.vue?vue&type=template&id=8e864406&scoped=true"
import script from "./EditAccountDetailPage.vue?vue&type=script&lang=js"
export * from "./EditAccountDetailPage.vue?vue&type=script&lang=js"
import style0 from "./EditAccountDetailPage.vue?vue&type=style&index=0&id=8e864406&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e864406",
  null
  
)

export default component.exports